import { render } from "./WebsiteInput.vue?vue&type=template&id=28bea17a&scoped=true"
import script from "./WebsiteInput.vue?vue&type=script&lang=js"
export * from "./WebsiteInput.vue?vue&type=script&lang=js"

import "./WebsiteInput.vue?vue&type=style&index=0&id=28bea17a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28bea17a"]])

export default __exports__